import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BillingForm } from "Bands/containers";
import { copy } from "shared/assets";
import { Company } from "shared/assets/icons";
import { Modal } from "shared/components";
import { createCompany, dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS, ICompany } from "Bands/types";
import { IAPIState } from "shared/types";
import { useClearActionMetaOnUnMount, useInvalidVATError } from "Bands/utils";

const billingInfoCopy = copy.subscription.billingInfo;

interface BillingFormModalProps {
  handleClose: () => void;
}

export const BillingFormModal: FC<BillingFormModalProps> = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.createCompany));
  useClearActionMetaOnUnMount(BAND_ACTIONS.createCompany);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();
    }
  }, [apiMeta?.status, handleClose]);

  const handleSubmit = (data: Omit<ICompany, "id">) => {
    dispatch(createCompany(data));
  };

  const { error } = useInvalidVATError(BAND_ACTIONS.createCompany);

  return (
    <Modal
      icon={Company}
      title={billingInfoCopy.modalTitle}
      handleClose={handleClose}
      dataTestId="billing_info_modal"
    >
      <BillingForm
        handleSubmit={handleSubmit}
        buttons={{
          primary: {
            children: billingInfoCopy.modalTitle,
            "data-testid": "submit_billing_info",
          },
          secondary: { onClick: handleClose },
        }}
        apiStatus={apiMeta?.status}
        error={error}
        apiError={apiMeta?.error}
      />
    </Modal>
  );
};
